import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { handleLogin, handleLogout } from '../../actions/auth'

import {
  Avatar,
  Badge,
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuItem,
  Modal,
  ListItemIcon,
  Tooltip,
  Typography,
  } from "@mui/material";
import { SnackbarProvider, useSnackbar } from 'notistack';

import { Link } from "react-router-dom";

import { Navigate, Routes, Route } from 'react-router-dom';

import HomePage from "../../pages/HomePage";

import tableIcons from "../tableFormatting/tableIcons";

import Logout from "@mui/icons-material/Logout";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";

import WizardModal from "../WizardModal";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const LoginActions = props => {

  const auth = props;
  // console.log(auth)


  const [openModal, setOpenModal] = useState(false);
  const [counter, setCounter] = useState(0)

  const handleOpenModal = () => {
    setOpenModal(true);
    setCounter(counter + 1)
  }
  const handleCloseModal = () => setOpenModal(false);


  const [isNewUser, setIsNewUser] = useState(false);
  const [wizardHelp, setWizardHelp] = useState(false);

  if (auth.authError == "New User") {
    // alert("NEW USER")
    console.log("NEW USER")
    setIsNewUser(true);


  } else {
    console.log("NOT NEW USER")
  }

  const [selected, setSelected] = useState(-1);

  const onMenuItemClick = (event, index) => {
    // setAnchor(null);
    setSelected(index);
    // setIcon("menu");
};



  // console.log((auth.auth.displayName))
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const name = auth.auth.displayName
  const [lastSeen, setLastSeen] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const [userName, setUserName] = useState(name);
  const [logOut, setLogOut] = useState(false);


  useEffect(() => {
    setUserName(auth.auth.displayName)
    setLastSeen(auth.lastLoginAt)
  },[])

  // console.log(auth)

  useEffect(() => {
    setLogOut(true);
    // if(name != undefined && performance.navigation.type != 1) {
    if(name != undefined && lastSeen == auth.lastLoginAt) {
      enqueueSnackbar("Welcome " + name + "!", { variant: "success" })
    }

    // console.log(props.dispatch)
   
    setTimeout(() => {
      setLogOut(false);
    }, 2000)
  
  },[name])



  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const pages = [
    {name:"Home", address:"/ ", icon: "HomeIcon"},
    // {name: "My competencies", address: "/mycompetencies"},
    {name: "Nanocompetencies", address: "/nanocompetencies", icon: "SchoolIcon"},
    // {name: "My Studies", address: "/mystudies"},
];

  // console.log(auth)

  // useEffect(() => {
  //   setUserName(auth.auth.displayName);
  //   console.log(userName)

  //   if(!auth.auth.displayName) {
  //   // } else {
  //     setUserName("no username");
  //   }

  // }, [props.dispatch]);

// useEffect(() => {
//   if(!auth.auth.uid) {
//     console.log("not logged in")
//     return (
//       // <Navigate to={{ pathname: "/nanocompetencies" }} />
//       <Routes>
//         <Route exact path="/" element={!auth.auth.uid && <HomePage />} />
// {/* <Route element={!auth.auth.uid && <Navigate to="/" />}/> */}
// </Routes>
//     )
//   }

// },[auth])

// console.log(auth)
// console.log(auth.auth.uid + " UID")
// console.log(props.dispatch)

// console.log(props.dispatch)
// console.log(userName)

// console.log(wizardHelp)


const notiData = [
  {
    id: 0,
    author: "Greg McLanes",
    type: "feedback",
    name: "Data Visualisation",
    description: "Hi! That was a great analysis of Heatmapping! 10/10",
    date: "29-May-2020",
    icon: "CommentIcon",
  },
  {
    id: 1,
    author: "Milla Martiini",
    type: "like",
    name: "Data Visualisation",
    description: "Liked your comment!",
    date: "29-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 2,
    author: "Steve Gimbles",
    type: "like",
    name: "Professional Communication",
    description: "Liked your comment!",
    date: "28-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 3,
    author: "Barney Roots",
    type: "reminder",
    name: "Professional Communication",
    description: "Your fith assignment is due in 2 days, good luck!",
    date: "27-May-2020",
    icon: "PriorityHighIcon",
  },
  {
    id: 4,
    author: "Anna Koivunen",
    type: "like",
    name: "Professional Communication",
    description: "Liked your comment!",
    date: "27-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 5,
    author: "Greg McLanes",
    type: "feedback",
    name: "Data Visualisation",
    description: "I think you should pay more attention to the theory side before attempting the quiz, otherwise all good for module 2!",
    date: "27-May-2020",
    icon: "CommentIcon",
  },
  {
    id: 6,
    author: "Tina Baker",
    type: "like",
    name: "Professional Communication",
    description: "Liked your comment!",
    date: "26-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 7,
    author: "Rosa Parkki",
    type: "like",
    name: "Data Visualisation",
    description: "Liked your comment!",
    date: "26-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 8,
    author: "Greg McLanes",
    type: "submission",
    name: "Data Visualisation",
    description: "Submission received! I will look into this as soon as possible",
    date: "23-May-2020",
    icon: "Check",
  },
  {
    id: 9,
    author: "Barney Roots",
    type: "submission",
    name: "Professional Communication",
    description: "Submission received! I will look into this as soon as possible",
    date: "23-May-2020",
    icon: "Check",
  },
  {
    id: 10,
    author: "Barney Roots",
    type: "reminder",
    name: "Professional Communication",
    description: "Your fifth assignment is due in 2 days, good luck!",
    date: "22-May-2020",
    icon: "PriorityHighIcon",
  },
  {
    id: 11,
    author: "Barney Roots",
    type: "like",
    name: "Artificial Intelligence",
    description: "Liked your comment!",
    date: "20-May-2020",
    icon: "ThumbUpIcon",
  },
  {
    id: 12,
    author: "Melissa Uronen",
    type: "like",
    name: "Artificial Intelligence",
    description: "Liked your comment!",
    date: "20-May-2020",
    icon: "ThumbUpIcon",
  },
];

const [notificationCount, setNotificationCount] = useState(notiData.length);
console.log(auth)

  const handleWizardHelp = () => {
    setWizardHelp(true);
  }


  const handleLogOut = () => {
    setLogOut(true);
    enqueueSnackbar("Successfully logged out!", { variant: "success" })
  
      props.dispatch(handleLogout())
 
    // setTimeout(() => {
      setLogOut(false);
    // }, 4000)
  }



    function stringToColor(userName) {
      let hash = 0;
      let i;
      if(userName != undefined) {
      /* eslint-disable no-bitwise */
      for (i = 0; i < userName.length; i += 1) {
        hash = userName.charCodeAt(i) + ((hash << 5) - hash);
      }
    
      let color = '#';
    
      for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
      }
      /* eslint-enable no-bitwise */
    
      return color;
      } 
    }

    function stringAvatar(userName) {
      if(userName != undefined) {
      return {
        sx: {
          bgcolor: stringToColor(userName),
          fontSize: "14px",
        },
        children: `${userName.split(' ')[0][0]}${userName.split(' ')[1][0]}`,
      };
    } 
    }


  return (
    <div style={{ right: "1vw", position: "absolute"}}>

      {!auth.auth.uid ? (
      
        <Button 
          variant="outlined" 
          onClick={() => props.dispatch(handleLogin())} 
          style={{ borderRadius: 99 }}>
            Log in 
        </Button>
            
          ) : (
            <>
         

            <div>
              <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Menu">
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    style={{ opacity: "80%" }}
                  >
                        <Badge color="primary" anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={notificationCount}>
              {anchorEl == null ? (
                    <tableIcons.MenuIcon />

              ) : (
                <tableIcons.Close />
              )}
                    </Badge>
                  </IconButton>
                </Tooltip>
              </Box>
                <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                elevation: 0,
                sx: {
                  maxWidth: "40vw",
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                >
{/* 
{pages.map((page, index, icon) => (
  <div>
                    <MenuItem
                        key={index}
                        onClick={(page) => onMenuItemClick(page, index)}
                        selected= {index === selected}
                    >
                      <Avatar> 
                    <tableIcons fontSize="small"> {icon}</tableIcons>

                      </Avatar>
                        <Link to={page.address} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                            {page.name}
                        </Link>
                    </MenuItem>
                    <Divider />
                    </ div>
                    ))} */}
{/*                   
                <MenuItem>
                  <Avatar /> Profile
                </MenuItem>
                <MenuItem>
                  <Avatar /> My account
                </MenuItem>
                <Divider /> */}
  
                <MenuItem 
                  style={{  
                    textOverflow: "ellipsis",
                    overflow: "hidden" 
                }}>
                    <Avatar {...stringAvatar(userName)} style={{ color: "#000", height: "30px", width: "30px" }} />
                    <List style={{ margin: "-25px -15px -15px -15px" }}>
                    <ListItem style={{ margin: "-10px 0 -30px 0" }}>
                    <p style={{ fontSize: "12px" }}>Logged in as:</p>
                    </ListItem>
                    <ListItem style={{ margin: "-15px 0 -10px 0", width: "200px", textOverflow: "ellipsis",
                        overflow: "hidden" }}>
                    <div
                      style={{  
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                    }}>
                      {auth.auth.displayName}
                    </div>
                    </ListItem>
                    </List>
                </MenuItem>

  <Divider />
                <MenuItem>
                  <ListItemIcon>
                    <tableIcons.HomeIcon fontSize="small" />
                  </ListItemIcon>
                  <Link to={"/ "} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                  Home
                  </Link>
                </MenuItem>
                <Divider />

                <MenuItem>
                  <ListItemIcon>
                    <tableIcons.SchoolIcon fontSize="small" />
                  </ListItemIcon>
                  <Link to={"/nanocompetencies"} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                  NanoCompetencies
                  </Link>
                </MenuItem>
                <Divider />

                <MenuItem>
                  <ListItemIcon>
                    <tableIcons.CommentIcon fontSize="small" />
                  </ListItemIcon>
                  <Link to={"/discussion"} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                  Discussion Board
                  </Link>
                </MenuItem>
                <Divider />
                <MenuItem onClick={() => setNotificationCount(0) }>
                  <ListItemIcon>
                  <Badge color="primary" anchorOrigin={{ vertical: "top", horizontal: "left" }} badgeContent={notificationCount}>

                    <tableIcons.NotificationsActiveIcon fontSize="small" />

                    </Badge>
                  </ListItemIcon>
                  <Link to={"/notifications"} style={{ textDecoration: "none", color: "#000", width: "100%", height: "100%"}}>
                  Notifications
                  </Link>
                </MenuItem>
                <Divider />

                <MenuItem onClick={() => handleOpenModal()}>
                  <ListItemIcon>
                    <tableIcons.QuestionMarkRoundedIcon fontSize="small" />
                  </ListItemIcon>
                  Help
                </MenuItem>
                <Divider />

                {/* <MenuItem>
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem> */}
                <MenuItem onClick={() => handleLogOut()}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Log Out
                </MenuItem>
              </Menu>   
            </div>
              


{openModal == true && (
 <WizardModal auth={auth} counter={counter} isNewUser={isNewUser} wizardHelp={openModal} />
)}




{/* 
              {auth.authError == "New User" || wizardHelp == true &&
                <WizardModal isNewUser={isNewUser} wizardHelp={wizardHelp} auth={auth} />
              } */}
               
               </>
          )}
    </div>
    )
  }

const mapStateToProps = ({auth, firebase}) => {
  return {
    auth: firebase.auth,
    authError: auth.authError
  }
}

export default connect(mapStateToProps)(LoginActions)